module.exports = __webpack_public_path__ + "assets/img/backp.4e389d45.png";